import React from 'react'
import { MaxValueLabel, MinValueLabel, SliderC, SliderWrapper } from '~/pages/Dairy/Survey/ShowSurvey/CreateEditQuestion/QuestionForms/Slider'
import { SliderContainer } from '../style'
import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'

const RaceSlider: React.FC = () => {
  const { control, setValue } = useFormContext()
  const { t } = useTranslation()

  const watchSecondRacePercent = useWatch({ control, name: 'breeds[1].percent' })

  return <SliderContainer>
    <SliderWrapper>
      <MinValueLabel style={{ fontWeight: 'normal' }}>{'0%'}</MinValueLabel>
      <SliderC
        step={1}
        rating={watchSecondRacePercent / 49 * 100}
        min={0}
        max={49}
        value={watchSecondRacePercent}
        onChange={(e) => {
          setValue('breeds[1].percent', e.target.value)
          setValue('breeds[0].percent', 100 - parseInt(e.target.value))
        }}
      />
      <MaxValueLabel style={{ fontWeight: 'normal' }}>{t('49%')}</MaxValueLabel>
    </SliderWrapper>
  </SliderContainer>
}
export default RaceSlider